module.exports = __webpack_public_path__ + "static/media/error.8117566e.svg";